import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Swiper } from '@tencent/slug-ui';
import JumpLinksMixin from '@/mixins/JumpLinksMixin';
import { replaceImgToCloud } from '@utils/cloud-img.js';
interface ListItem {
  id: string;
  images: string;
  title?: string;
  url?: string;
  disabled?: boolean;
  ptt?: [string, string, string, string?];
  // dmp?: {
  //   [propName: string]: any;
  // };
  isCloseFullScreen?: boolean
}

@Component({
  components: {
    'sui-swiper': Swiper,
  },
})
// export default class GpSwiper extends mixins(JumpLinksMixin)  {
export default class GpSwiper extends mixins(JumpLinksMixin) {
  @Prop({ type: Array, default: () => [] })
  public list!: any[];

  public curSwiperPage = 0;
  public autoPlay = window.location.href.indexOf('localhost') < 0;

  public changeSwiper(index: number) {
    const { curSwiperPage } = this;
    if (curSwiperPage === index) return;
    this.curSwiperPage = index;
    this.$emit('change', index);
  }

  public toUrl(item: ListItem) {
    const { disabled, url, isCloseFullScreen, ptt } = item;
    if (ptt) {
      window.PTTRun && window.PTTSendReport({
        action: 'btn',
        hottag: `${ptt && ptt[0]}_${ptt && ptt[1]}_${ptt && ptt[2]}`,
        fortest4: ptt && ptt[3],
      });
    }


    if (disabled) return;
    if (typeof url === 'string') {
      this.jumpLinks(url, isCloseFullScreen);
    }
  }
  public handleImg(url: string, config: string) {
    return replaceImgToCloud(url, config);
  }
}
